var map = {
	"./1800X.jpg": 93,
	"./2600K.jpg": 94,
	"./3950X.jpg": 95,
	"./4004.jpg": 96,
	"./4770K.jpg": 97,
	"./603E.jpg": 98,
	"./6502.jpg": 99,
	"./68000.jpg": 100,
	"./68020.jpg": 101,
	"./68030.jpg": 102,
	"./68040.jpg": 103,
	"./750.jpg": 104,
	"./80286.jpg": 105,
	"./80386DX.jpg": 106,
	"./80486DX.jpg": 107,
	"./80486DX2.jpg": 108,
	"./80486DX4.jpg": 109,
	"./8080.jpg": 110,
	"./8086.jpg": 111,
	"./8088.jpg": 112,
	"./9900K.jpg": 113,
	"./ATHLON.jpg": 114,
	"./ATHLONFX57.jpg": 115,
	"./ATHLONFX60.jpg": 116,
	"./ATHLONXP.jpg": 117,
	"./PENTIUM.jpg": 118,
	"./PENTIUM3.jpg": 119,
	"./PENTIUM4.jpg": 120,
	"./PENTIUMPRO.jpg": 121,
	"./QX6700.jpg": 122,
	"./QX9770.jpg": 123,
	"./Z80.jpg": 124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92;